export const datesHelper = {
  methods: {
    replaceDashes(date) {
      return new Date(date.replace(/-/g, "/"));
    },
  },
};
